import { render, staticRenderFns } from "./funesF.vue?vue&type=template&id=1840a714"
import script from "./funesF.vue?vue&type=script&lang=js"
export * from "./funesF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports